// The proprietary print implementation was not embedded in the published
// source map. Tiangong keeps the Luckysheet print plugin disabled, so expose a
// safe stub while rebuilding the customized bundle.
export const luckysheetPrint = null;
